import styled from "@emotion/styled";

const darkBlue = "rgb(13, 103, 151)";
// 10% lighter version of darkBlue: rgb(37, 118, 162)
const darkBlueHover = "rgb(37, 118, 162)";

export const StyledButton = styled.button`
  font-family: "Coda", cursive;
  font-weight: 300 !important;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding-top: 0.9em;
  padding-bottom: 0.8em;
  padding-right: 1em;
  padding-left: 1em;
  border: 1px solid transparent;
  cursor: pointer;
  background: ${darkBlue};
  color: #fff;

  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 1rem;

  &:hover {
    background: ${darkBlueHover};
  }
`;
